import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from '@angular/core';
import { AuthService } from '@app/core/services';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'app-rc-no-content',
  templateUrl: './rc-no-content.component.html',
  styleUrls: ['./rc-no-content.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [TranslatePipe],
})
export class RcNoContentComponent {
  @Input() retryButton = true;
  @Output() retryAction: EventEmitter<boolean> = new EventEmitter();

  constructor(private _authService: AuthService) {}

  retry() {
    this.retryAction.emit();
  }

  logout() {
    this._authService.logout();
  }
}
